/**
 * helper dla słowników
 */
angular.module('ihestiaRestServicesBase')
  .service('lsnDictionaryHelper', ['lsnDictionarySvc', '$q',
    function(lsnDictionarySvc, $q) {

      var standardDictItems = {};

      var DictionaryHelper = function() {
        var self = this;

        /**
         * Przelotka na getStandardDictItems
         * @param  {array} codes tablica kodów słowników
         * @param  {Object} svc   serwis dziedziczący po IHestiaRestServiceAbstractDef
         * @return {promise} słowniki (np. then(res.data) -> {POLICY_TYPES: [{code: 'x', name: 'xyz'}]})
         */
        this.getStandardDictBySvc = function(codes, svc) {
          return self.getStandardDictItems(codes, null, {
            svc: svc
          });
        };

        /**
         * Zwraca promise z żądanymi słownikami
         * @param  {array} codes tablica kodów słowników
         * @return {promise} słowniki (np. then(res.data) -> {POLICY_TYPES: [{code: 'x', name: 'xyz'}]})
         */
        this.getStandardDictItems = function(codes, businessArea, params) {
          if(!angular.isObject(params) || params === null) {
            params = {};
          }
          var dictSvc = params.svc ? params.svc : lsnDictionarySvc;
          if(!params.svc && businessArea)
          {
            dictSvc.businessArea = businessArea;
            if(businessArea === 'iszkody')
            {
              dictSvc.basePattern = '{host}{port}{path}/{businessArea}/{apiString}/secured/{resource}{id}{subResource}';
            }
          }
          if(!angular.isArray(codes)) {
            codes = [codes];
          }
          return $q(function(resolve, reject){
            // sprawdzamy, czy w ogóle musimy wołać usługę
            var dictsToFetch = [];
            angular.forEach(codes, function(dictCode){
              if(!standardDictItems[dictCode]) {
                dictsToFetch.push(dictCode);
              }
            });

            // jeśli trzeba, to ładujemy je
            if(dictsToFetch.length > 0) {
              dictSvc.get(null, {
                codes: dictsToFetch.join(','),
                details: true
              }).then(function(res){
                if(res && res.status === 200 && angular.isArray(res.data)) {
                  angular.forEach(res.data, function(dict){
                    standardDictItems[dict.code] = dict.items;
                  });
                  resolve(self._getStandardDictItemsFromCache(codes));
                } else {
                  reject();
                }
              }, reject);
            } else {
              // mamy już wszysko zaciągnięte
              resolve(self._getStandardDictItemsFromCache(codes));
            }
          });
        };

        /**
         * Zwraca obiekt z żądanymi słownikami z wewnętrznego cache (js)
         * funkcja wewnętrzna - nie używać poza tym helperem
         * @param  {array} codes tablica kodów słowników
         * @return {object} słowniki (np. {POLICY_TYPES: [{code: 'x', name: 'xyz'}]})
         */
        this._getStandardDictItemsFromCache = function(codes) {
          var dicts = {};
          angular.forEach(codes, function(dictCode){
            dicts[dictCode] = standardDictItems[dictCode];
          });

          return dicts;
        };

      };

      return new DictionaryHelper();
    }
  ]);